/* eslint-disable global-require */

'use-strict';

import { RouteProvider } from '../../app.upgraded.routes';

/* @ngInject */
export default function routing(
  $routeProvider: RouteProvider,
): void {
  $routeProvider
    .when('/settings/config', {
      templateUrl: require('./configuration/configuration.template.html'),
      title: 'Konfiguration',
    });
}
